<template>
  <div
    data-slot="carousel"
    :class="cn('tw:relative', props.class)"
    role="region"
    :aria-roledescription="t('common.carousel')"
    tabindex="0"
    @keydown="onKeyDown"
  >
    <slot
      :can-scroll-prev="canScrollPrev"
      :can-scroll-next="canScrollNext"
      :carousel-api="carouselApi"
      :scroll-prev="scrollPrev"
      :scroll-next="scrollNext"
    />
  </div>
</template>

<script setup>
// 1. Import necessary components
defineOptions({ name: 'UiCarousel' });
import { cn } from '@/shared/utilities/classes';
import { useI18n } from 'vue-i18n';
import { useProvideCarousel } from './useCarousel';

// 2. Use
const { t } = useI18n();
const props = defineProps({
  opts: { default: () => ({}), type: Object, required: false },
  plugins: { default: () => [], type: Array, required: false },
  orientation: { default: 'horizontal', type: String, required: false },
  class: {
    default: undefined,
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const emits = defineEmits(['init-api']);

const {
  canScrollNext,
  canScrollPrev,
  carouselApi,
  carouselRef,
  orientation,
  scrollNext,
  scrollPrev,
} = useProvideCarousel(props, emits);

defineExpose({
  canScrollNext,
  canScrollPrev,
  carouselApi,
  carouselRef,
  orientation,
  scrollNext,
  scrollPrev,
});

// 3. Define a reactive variable
// 4. Define methods or computed properties if needed
function onKeyDown(event) {
  let prevKey = 'ArrowLeft';
  let nextKey = 'ArrowRight';
  if (props.orientation === 'vertical') {
    prevKey = 'ArrowUp';
    nextKey = 'ArrowDown';
  }

  if (event.key === prevKey) {
    event.preventDefault();
    scrollPrev();
    return;
  }

  if (event.key === nextKey) {
    event.preventDefault();
    scrollNext();
  }
}
// 5. VueJS Hooks
</script>
